import PropTypes from "prop-types";
import icons from "../icons";
import GrButton from "./GrButton";
import GrIcon from "./GrIcon";
import GrCountBadge from "./GrCountBadge";

// The button that opens a GrFilterDrawer: outline (teal border + text, so it reads as a control
// at rest), icon, the page's own label, then the number of filters in use (hidden at 0).
export default function GrFilterButton({
  children,
  onClick,
  count = 0,
  icon = icons.filter,
  size = "md",
  ...rest
}) {
  return (
    <GrButton
      variant="outline"
      size={size}
      startIcon={<GrIcon icon={icon} size={size === "sm" ? "sm" : "md"} />}
      onClick={onClick}
      aria-haspopup="dialog"
      {...rest}
    >
      {children}
      <GrCountBadge count={count} />
    </GrButton>
  );
}

GrFilterButton.propTypes = {
  // The page's label, e.g. "Filters" or "Filter by date".
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  // Filters in use; 0 shows no badge.
  count: PropTypes.number,
  icon: PropTypes.object,
  size: PropTypes.oneOf(["sm", "md"]),
};
